import { useMutation, useQueryClient } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";

const API = process.env.REACT_APP_API;

const useDuplicateOfferings = () => {
  const queryClient = useQueryClient();
  const fetch = useFetch();

  return useMutation({
    mutationFn: (fairId: number) => {
      return fetch(
        `${API}/api/semeadora/fairs/${fairId}/offerings/duplicate/`,
        {
          method: "POST",
        },
      );
    },
    onSuccess: (_, fairId) => {
      queryClient.invalidateQueries({
        queryKey: ["product-offerings", fairId],
      });
    },
    onError: (error) => {
      console.log("onError", error);
    },
  });
};

export default useDuplicateOfferings;
